/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Framework = $root.Framework = (() => {

    const Framework = {};

    Framework.SecurityModel = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UnlimitedLogin"] = 0;
        values[valuesById[1] = "KickOff"] = 1;
        values[valuesById[2] = "OnlyOneAllowed"] = 2;
        return values;
    })();

    Framework.OrderBy = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Asc"] = 0;
        values[valuesById[-1] = "Unsorted"] = -1;
        values[valuesById[1] = "Desc"] = 1;
        return values;
    })();

    Framework.Estate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Stop"] = 0;
        values[valuesById[-1] = "Delete"] = -1;
        values[valuesById[1] = "Normal"] = 1;
        return values;
    })();

    Framework.MessageType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Common"] = 0;
        values[valuesById[1] = "JoinGroup"] = 1;
        values[valuesById[2] = "QuitGroup"] = 2;
        values[valuesById[10] = "StateSync"] = 10;
        values[valuesById[11] = "ALLStateSync"] = 11;
        values[valuesById[20] = "WebSocketSync"] = 20;
        values[valuesById[99] = "Dispatch"] = 99;
        values[valuesById[100] = "SyncDispatch"] = 100;
        values[valuesById[101] = "DispatchResponse"] = 101;
        return values;
    })();

    Framework.Message = (function () {

        function Message(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Message.prototype.ID = "";
        Message.prototype.Type = 0;
        Message.prototype.Data = null;
        Message.prototype.GroupName = "";
        Message.prototype.IsRepeat = false;
        Message.prototype.SyncID = "";

        Message.create = function create(properties) {
            return new Message(properties);
        };

        Message.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Type != null && Object.hasOwnProperty.call(m, "Type"))
                w.uint32(16).int32(m.Type);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data"))
                $root.google.protobuf.Any.encode(m.Data, w.uint32(26).fork()).ldelim();
            if (m.GroupName != null && Object.hasOwnProperty.call(m, "GroupName"))
                w.uint32(34).string(m.GroupName);
            if (m.IsRepeat != null && Object.hasOwnProperty.call(m, "IsRepeat"))
                w.uint32(40).bool(m.IsRepeat);
            if (m.SyncID != null && Object.hasOwnProperty.call(m, "SyncID"))
                w.uint32(50).string(m.SyncID);
            return w;
        };

        Message.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.Message();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Type = r.int32();
                        break;
                    }
                    case 3: {
                        m.Data = $root.google.protobuf.Any.decode(r, r.uint32());
                        break;
                    }
                    case 4: {
                        m.GroupName = r.string();
                        break;
                    }
                    case 5: {
                        m.IsRepeat = r.bool();
                        break;
                    }
                    case 6: {
                        m.SyncID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Message.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.Message";
        };

        return Message;
    })();

    Framework.GroupInfo = (function () {

        function GroupInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GroupInfo.prototype.GroupName = "";
        GroupInfo.prototype.Data = null;

        GroupInfo.create = function create(properties) {
            return new GroupInfo(properties);
        };

        GroupInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GroupName != null && Object.hasOwnProperty.call(m, "GroupName"))
                w.uint32(10).string(m.GroupName);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data"))
                $root.google.protobuf.Any.encode(m.Data, w.uint32(26).fork()).ldelim();
            return w;
        };

        GroupInfo.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.GroupInfo();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.GroupName = r.string();
                        break;
                    }
                    case 3: {
                        m.Data = $root.google.protobuf.Any.decode(r, r.uint32());
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GroupInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.GroupInfo";
        };

        return GroupInfo;
    })();

    Framework.Diff_Data = (function () {

        function Diff_Data(p) {
            this.Datas = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Diff_Data.prototype.Type = "";
        Diff_Data.prototype.ID = "";
        Diff_Data.prototype.Datas = $util.emptyObject;

        Diff_Data.create = function create(properties) {
            return new Diff_Data(properties);
        };

        Diff_Data.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Type != null && Object.hasOwnProperty.call(m, "Type"))
                w.uint32(10).string(m.Type);
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(18).string(m.ID);
            if (m.Datas != null && Object.hasOwnProperty.call(m, "Datas")) {
                for (var ks = Object.keys(m.Datas), i = 0; i < ks.length; ++i) {
                    w.uint32(26).fork().uint32(10).string(ks[i]);
                    $root.google.protobuf.Value.encode(m.Datas[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            return w;
        };

        Diff_Data.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.Diff_Data(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Type = r.string();
                        break;
                    }
                    case 2: {
                        m.ID = r.string();
                        break;
                    }
                    case 3: {
                        if (m.Datas === $util.emptyObject)
                            m.Datas = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.string();
                                    break;
                                case 2:
                                    value = $root.google.protobuf.Value.decode(r, r.uint32());
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.Datas[k] = value;
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Diff_Data.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.Diff_Data";
        };

        return Diff_Data;
    })();

    Framework.Diff_Datas = (function () {

        function Diff_Datas(p) {
            this.Datas = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Diff_Datas.prototype.Type = "";
        Diff_Datas.prototype.Datas = $util.emptyArray;

        Diff_Datas.create = function create(properties) {
            return new Diff_Datas(properties);
        };

        Diff_Datas.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Type != null && Object.hasOwnProperty.call(m, "Type"))
                w.uint32(10).string(m.Type);
            if (m.Datas != null && m.Datas.length) {
                for (var i = 0; i < m.Datas.length; ++i)
                    $root.Framework.Diff_Data.encode(m.Datas[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        Diff_Datas.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.Diff_Datas();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Type = r.string();
                        break;
                    }
                    case 2: {
                        if (!(m.Datas && m.Datas.length))
                            m.Datas = [];
                        m.Datas.push($root.Framework.Diff_Data.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Diff_Datas.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.Diff_Datas";
        };

        return Diff_Datas;
    })();

    Framework.Operating = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "None"] = 0;
        values[valuesById[1] = "View"] = 1;
        values[valuesById[2] = "Add"] = 2;
        values[valuesById[4] = "Modify"] = 4;
        values[valuesById[8] = "Del"] = 8;
        values[valuesById[16] = "Print"] = 16;
        values[valuesById[32] = "Export"] = 32;
        values[valuesById[64] = "Import"] = 64;
        values[valuesById[1024] = "Run"] = 1024;
        values[valuesById[2048] = "Approve"] = 2048;
        values[valuesById[268435456] = "Register"] = 268435456;
        values[valuesById[536870912] = "Logout"] = 536870912;
        values[valuesById[1073741824] = "Login"] = 1073741824;
        return values;
    })();

    Framework.OperatingLog = (function () {

        function OperatingLog(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OperatingLog.prototype.LogID = "";
        OperatingLog.prototype.LogTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OperatingLog.prototype.UserID = "";
        OperatingLog.prototype.UserName = "";
        OperatingLog.prototype.Service = "";
        OperatingLog.prototype.Module = "";
        OperatingLog.prototype.DataID = "";
        OperatingLog.prototype.DataContent = "";
        OperatingLog.prototype.Action = 0;
        OperatingLog.prototype.Result = false;
        OperatingLog.prototype.Data = "";
        OperatingLog.prototype.RequestIP = "";
        OperatingLog.prototype.SubAction = "";
        OperatingLog.prototype.Content = "";
        OperatingLog.prototype.Remark = "";

        OperatingLog.create = function create(properties) {
            return new OperatingLog(properties);
        };

        OperatingLog.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.LogID != null && Object.hasOwnProperty.call(m, "LogID"))
                w.uint32(10).string(m.LogID);
            if (m.LogTime != null && Object.hasOwnProperty.call(m, "LogTime"))
                w.uint32(16).int64(m.LogTime);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(26).string(m.UserID);
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(34).string(m.UserName);
            if (m.Service != null && Object.hasOwnProperty.call(m, "Service"))
                w.uint32(42).string(m.Service);
            if (m.Module != null && Object.hasOwnProperty.call(m, "Module"))
                w.uint32(50).string(m.Module);
            if (m.DataID != null && Object.hasOwnProperty.call(m, "DataID"))
                w.uint32(58).string(m.DataID);
            if (m.DataContent != null && Object.hasOwnProperty.call(m, "DataContent"))
                w.uint32(66).string(m.DataContent);
            if (m.Action != null && Object.hasOwnProperty.call(m, "Action"))
                w.uint32(72).int32(m.Action);
            if (m.Result != null && Object.hasOwnProperty.call(m, "Result"))
                w.uint32(80).bool(m.Result);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data"))
                w.uint32(90).string(m.Data);
            if (m.RequestIP != null && Object.hasOwnProperty.call(m, "RequestIP"))
                w.uint32(98).string(m.RequestIP);
            if (m.SubAction != null && Object.hasOwnProperty.call(m, "SubAction"))
                w.uint32(106).string(m.SubAction);
            if (m.Content != null && Object.hasOwnProperty.call(m, "Content"))
                w.uint32(114).string(m.Content);
            if (m.Remark != null && Object.hasOwnProperty.call(m, "Remark"))
                w.uint32(122).string(m.Remark);
            return w;
        };

        OperatingLog.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.OperatingLog();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.LogID = r.string();
                        break;
                    }
                    case 2: {
                        m.LogTime = r.int64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.string();
                        break;
                    }
                    case 4: {
                        m.UserName = r.string();
                        break;
                    }
                    case 5: {
                        m.Service = r.string();
                        break;
                    }
                    case 6: {
                        m.Module = r.string();
                        break;
                    }
                    case 7: {
                        m.DataID = r.string();
                        break;
                    }
                    case 8: {
                        m.DataContent = r.string();
                        break;
                    }
                    case 9: {
                        m.Action = r.int32();
                        break;
                    }
                    case 10: {
                        m.Result = r.bool();
                        break;
                    }
                    case 11: {
                        m.Data = r.string();
                        break;
                    }
                    case 12: {
                        m.RequestIP = r.string();
                        break;
                    }
                    case 13: {
                        m.SubAction = r.string();
                        break;
                    }
                    case 14: {
                        m.Content = r.string();
                        break;
                    }
                    case 15: {
                        m.Remark = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OperatingLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.OperatingLog";
        };

        return OperatingLog;
    })();

    Framework.OperatingLogs = (function () {

        function OperatingLogs(p) {
            this.Logs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OperatingLogs.prototype.Logs = $util.emptyArray;

        OperatingLogs.create = function create(properties) {
            return new OperatingLogs(properties);
        };

        OperatingLogs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Logs != null && m.Logs.length) {
                for (var i = 0; i < m.Logs.length; ++i)
                    $root.Framework.OperatingLog.encode(m.Logs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OperatingLogs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.OperatingLogs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Logs && m.Logs.length))
                            m.Logs = [];
                        m.Logs.push($root.Framework.OperatingLog.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OperatingLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.OperatingLogs";
        };

        return OperatingLogs;
    })();

    Framework.ContentType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ByRequest"] = 0;
        values[valuesById[1] = "Json"] = 1;
        return values;
    })();

    Framework.RequestToken = (function () {

        function RequestToken(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RequestToken.prototype.Timestamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        RequestToken.prototype.RequestID1 = "";
        RequestToken.prototype.RequestID2 = "";
        RequestToken.prototype.Check = 0;

        RequestToken.create = function create(properties) {
            return new RequestToken(properties);
        };

        RequestToken.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Timestamp != null && Object.hasOwnProperty.call(m, "Timestamp"))
                w.uint32(8).int64(m.Timestamp);
            if (m.RequestID1 != null && Object.hasOwnProperty.call(m, "RequestID1"))
                w.uint32(18).string(m.RequestID1);
            if (m.RequestID2 != null && Object.hasOwnProperty.call(m, "RequestID2"))
                w.uint32(26).string(m.RequestID2);
            if (m.Check != null && Object.hasOwnProperty.call(m, "Check"))
                w.uint32(32).uint32(m.Check);
            return w;
        };

        RequestToken.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.RequestToken();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Timestamp = r.int64();
                        break;
                    }
                    case 2: {
                        m.RequestID1 = r.string();
                        break;
                    }
                    case 3: {
                        m.RequestID2 = r.string();
                        break;
                    }
                    case 4: {
                        m.Check = r.uint32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        RequestToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.RequestToken";
        };

        return RequestToken;
    })();

    Framework.SafeURL = (function () {

        function SafeURL(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SafeURL.prototype.Token = null;
        SafeURL.prototype.URL = "";
        SafeURL.prototype.IsMedia = false;

        SafeURL.create = function create(properties) {
            return new SafeURL(properties);
        };

        SafeURL.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Token != null && Object.hasOwnProperty.call(m, "Token"))
                $root.Framework.RequestToken.encode(m.Token, w.uint32(10).fork()).ldelim();
            if (m.URL != null && Object.hasOwnProperty.call(m, "URL"))
                w.uint32(18).string(m.URL);
            if (m.IsMedia != null && Object.hasOwnProperty.call(m, "IsMedia"))
                w.uint32(24).bool(m.IsMedia);
            return w;
        };

        SafeURL.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.SafeURL();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Token = $root.Framework.RequestToken.decode(r, r.uint32());
                        break;
                    }
                    case 2: {
                        m.URL = r.string();
                        break;
                    }
                    case 3: {
                        m.IsMedia = r.bool();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SafeURL.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.SafeURL";
        };

        return SafeURL;
    })();

    Framework.Request = (function () {

        function Request(p) {
            this.Header = {};
            this.UploadFile = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Request.prototype.Name = "";
        Request.prototype.Method = "";
        Request.prototype.Data = $util.newBuffer([]);
        Request.prototype.Header = $util.emptyObject;
        Request.prototype.RemoteAddr = "";
        Request.prototype.UploadFile = $util.emptyArray;
        Request.prototype.RequestURI = "";
        Request.prototype.ID = "";
        Request.prototype.SyncID = "";

        Request.create = function create(properties) {
            return new Request(properties);
        };

        Request.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(10).string(m.Name);
            if (m.Method != null && Object.hasOwnProperty.call(m, "Method"))
                w.uint32(18).string(m.Method);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data"))
                w.uint32(26).bytes(m.Data);
            if (m.Header != null && Object.hasOwnProperty.call(m, "Header")) {
                for (var ks = Object.keys(m.Header), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.Header[ks[i]]).ldelim();
                }
            }
            if (m.RemoteAddr != null && Object.hasOwnProperty.call(m, "RemoteAddr"))
                w.uint32(42).string(m.RemoteAddr);
            if (m.UploadFile != null && m.UploadFile.length) {
                for (var i = 0; i < m.UploadFile.length; ++i)
                    $root.Framework.UploadFile.encode(m.UploadFile[i], w.uint32(50).fork()).ldelim();
            }
            if (m.RequestURI != null && Object.hasOwnProperty.call(m, "RequestURI"))
                w.uint32(58).string(m.RequestURI);
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(794).string(m.ID);
            if (m.SyncID != null && Object.hasOwnProperty.call(m, "SyncID"))
                w.uint32(802).string(m.SyncID);
            return w;
        };

        Request.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.Request(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Name = r.string();
                        break;
                    }
                    case 2: {
                        m.Method = r.string();
                        break;
                    }
                    case 3: {
                        m.Data = r.bytes();
                        break;
                    }
                    case 4: {
                        if (m.Header === $util.emptyObject)
                            m.Header = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.string();
                                    break;
                                case 2:
                                    value = r.string();
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.Header[k] = value;
                        break;
                    }
                    case 5: {
                        m.RemoteAddr = r.string();
                        break;
                    }
                    case 6: {
                        if (!(m.UploadFile && m.UploadFile.length))
                            m.UploadFile = [];
                        m.UploadFile.push($root.Framework.UploadFile.decode(r, r.uint32()));
                        break;
                    }
                    case 7: {
                        m.RequestURI = r.string();
                        break;
                    }
                    case 99: {
                        m.ID = r.string();
                        break;
                    }
                    case 100: {
                        m.SyncID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.Request";
        };

        return Request;
    })();

    Framework.UploadFile = (function () {

        function UploadFile(p) {
            this.Data = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UploadFile.prototype.FileID = "";
        UploadFile.prototype.Size = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        UploadFile.prototype.Content = $util.newBuffer([]);
        UploadFile.prototype.MD5 = "";
        UploadFile.prototype.Start = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        UploadFile.prototype.Data = $util.emptyObject;
        UploadFile.prototype.LastChunk = false;

        UploadFile.create = function create(properties) {
            return new UploadFile(properties);
        };

        UploadFile.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.FileID != null && Object.hasOwnProperty.call(m, "FileID"))
                w.uint32(10).string(m.FileID);
            if (m.Size != null && Object.hasOwnProperty.call(m, "Size"))
                w.uint32(16).int64(m.Size);
            if (m.Content != null && Object.hasOwnProperty.call(m, "Content"))
                w.uint32(26).bytes(m.Content);
            if (m.MD5 != null && Object.hasOwnProperty.call(m, "MD5"))
                w.uint32(34).string(m.MD5);
            if (m.Start != null && Object.hasOwnProperty.call(m, "Start"))
                w.uint32(40).int64(m.Start);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data")) {
                for (var ks = Object.keys(m.Data), i = 0; i < ks.length; ++i) {
                    w.uint32(50).fork().uint32(10).string(ks[i]).uint32(18).string(m.Data[ks[i]]).ldelim();
                }
            }
            if (m.LastChunk != null && Object.hasOwnProperty.call(m, "LastChunk"))
                w.uint32(56).bool(m.LastChunk);
            return w;
        };

        UploadFile.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.UploadFile(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.FileID = r.string();
                        break;
                    }
                    case 2: {
                        m.Size = r.int64();
                        break;
                    }
                    case 3: {
                        m.Content = r.bytes();
                        break;
                    }
                    case 4: {
                        m.MD5 = r.string();
                        break;
                    }
                    case 5: {
                        m.Start = r.int64();
                        break;
                    }
                    case 6: {
                        if (m.Data === $util.emptyObject)
                            m.Data = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.string();
                                    break;
                                case 2:
                                    value = r.string();
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.Data[k] = value;
                        break;
                    }
                    case 7: {
                        m.LastChunk = r.bool();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UploadFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.UploadFile";
        };

        return UploadFile;
    })();

    Framework.Data = (function () {

        function Data(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Data.prototype.StrContent = "";
        Data.prototype.Buffer = $util.newBuffer([]);

        Data.create = function create(properties) {
            return new Data(properties);
        };

        Data.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.StrContent != null && Object.hasOwnProperty.call(m, "StrContent"))
                w.uint32(10).string(m.StrContent);
            if (m.Buffer != null && Object.hasOwnProperty.call(m, "Buffer"))
                w.uint32(18).bytes(m.Buffer);
            return w;
        };

        Data.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.Data();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.StrContent = r.string();
                        break;
                    }
                    case 2: {
                        m.Buffer = r.bytes();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Data.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.Data";
        };

        return Data;
    })();

    Framework.BatchOperationRequest = (function () {

        function BatchOperationRequest(p) {
            this.IDs = [];
            this.Titles = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BatchOperationRequest.prototype.IDs = $util.emptyArray;
        BatchOperationRequest.prototype.Estate = null;
        BatchOperationRequest.prototype.Titles = $util.emptyArray;
        BatchOperationRequest.prototype.Module = "";
        BatchOperationRequest.prototype.Service = "";

        let $oneOfFields;

        Object.defineProperty(BatchOperationRequest.prototype, "_Estate", {
            get: $util.oneOfGetter($oneOfFields = ["Estate"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        BatchOperationRequest.create = function create(properties) {
            return new BatchOperationRequest(properties);
        };

        BatchOperationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.IDs != null && m.IDs.length) {
                for (var i = 0; i < m.IDs.length; ++i)
                    w.uint32(10).string(m.IDs[i]);
            }
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(16).int32(m.Estate);
            if (m.Titles != null && m.Titles.length) {
                for (var i = 0; i < m.Titles.length; ++i)
                    w.uint32(26).string(m.Titles[i]);
            }
            if (m.Module != null && Object.hasOwnProperty.call(m, "Module"))
                w.uint32(34).string(m.Module);
            if (m.Service != null && Object.hasOwnProperty.call(m, "Service"))
                w.uint32(42).string(m.Service);
            return w;
        };

        BatchOperationRequest.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.BatchOperationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.IDs && m.IDs.length))
                            m.IDs = [];
                        m.IDs.push(r.string());
                        break;
                    }
                    case 2: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 3: {
                        if (!(m.Titles && m.Titles.length))
                            m.Titles = [];
                        m.Titles.push(r.string());
                        break;
                    }
                    case 4: {
                        m.Module = r.string();
                        break;
                    }
                    case 5: {
                        m.Service = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        BatchOperationRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.BatchOperationRequest";
        };

        return BatchOperationRequest;
    })();

    Framework.OnlyIDReq = (function () {

        function OnlyIDReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OnlyIDReq.prototype.ID = "";

        OnlyIDReq.create = function create(properties) {
            return new OnlyIDReq(properties);
        };

        OnlyIDReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            return w;
        };

        OnlyIDReq.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.OnlyIDReq();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OnlyIDReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.OnlyIDReq";
        };

        return OnlyIDReq;
    })();

    Framework.KeyValueReq = (function () {

        function KeyValueReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        KeyValueReq.prototype.Key = "";
        KeyValueReq.prototype.Value = "";

        KeyValueReq.create = function create(properties) {
            return new KeyValueReq(properties);
        };

        KeyValueReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Key != null && Object.hasOwnProperty.call(m, "Key"))
                w.uint32(10).string(m.Key);
            if (m.Value != null && Object.hasOwnProperty.call(m, "Value"))
                w.uint32(18).string(m.Value);
            return w;
        };

        KeyValueReq.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.KeyValueReq();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Key = r.string();
                        break;
                    }
                    case 2: {
                        m.Value = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        KeyValueReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.KeyValueReq";
        };

        return KeyValueReq;
    })();

    Framework.ValidateValueExistReq = (function () {

        function ValidateValueExistReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ValidateValueExistReq.prototype.Value = "";
        ValidateValueExistReq.prototype.ParentID = null;
        ValidateValueExistReq.prototype.ID = "";
        ValidateValueExistReq.prototype.FieldName = "";
        ValidateValueExistReq.prototype.Module = "";
        ValidateValueExistReq.prototype.ParentFieldName = null;
        ValidateValueExistReq.prototype.TypeFieldName = null;
        ValidateValueExistReq.prototype.Type = null;
        ValidateValueExistReq.prototype.NeedAes = false;

        let $oneOfFields;

        Object.defineProperty(ValidateValueExistReq.prototype, "_ParentID", {
            get: $util.oneOfGetter($oneOfFields = ["ParentID"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        Object.defineProperty(ValidateValueExistReq.prototype, "_ParentFieldName", {
            get: $util.oneOfGetter($oneOfFields = ["ParentFieldName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        Object.defineProperty(ValidateValueExistReq.prototype, "_TypeFieldName", {
            get: $util.oneOfGetter($oneOfFields = ["TypeFieldName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        Object.defineProperty(ValidateValueExistReq.prototype, "_Type", {
            get: $util.oneOfGetter($oneOfFields = ["Type"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        ValidateValueExistReq.create = function create(properties) {
            return new ValidateValueExistReq(properties);
        };

        ValidateValueExistReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Value != null && Object.hasOwnProperty.call(m, "Value"))
                w.uint32(10).string(m.Value);
            if (m.ParentID != null && Object.hasOwnProperty.call(m, "ParentID"))
                w.uint32(18).string(m.ParentID);
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(26).string(m.ID);
            if (m.FieldName != null && Object.hasOwnProperty.call(m, "FieldName"))
                w.uint32(34).string(m.FieldName);
            if (m.Module != null && Object.hasOwnProperty.call(m, "Module"))
                w.uint32(42).string(m.Module);
            if (m.ParentFieldName != null && Object.hasOwnProperty.call(m, "ParentFieldName"))
                w.uint32(50).string(m.ParentFieldName);
            if (m.TypeFieldName != null && Object.hasOwnProperty.call(m, "TypeFieldName"))
                w.uint32(58).string(m.TypeFieldName);
            if (m.Type != null && Object.hasOwnProperty.call(m, "Type"))
                w.uint32(64).int32(m.Type);
            if (m.NeedAes != null && Object.hasOwnProperty.call(m, "NeedAes"))
                w.uint32(72).bool(m.NeedAes);
            return w;
        };

        ValidateValueExistReq.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.ValidateValueExistReq();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Value = r.string();
                        break;
                    }
                    case 2: {
                        m.ParentID = r.string();
                        break;
                    }
                    case 3: {
                        m.ID = r.string();
                        break;
                    }
                    case 4: {
                        m.FieldName = r.string();
                        break;
                    }
                    case 5: {
                        m.Module = r.string();
                        break;
                    }
                    case 6: {
                        m.ParentFieldName = r.string();
                        break;
                    }
                    case 7: {
                        m.TypeFieldName = r.string();
                        break;
                    }
                    case 8: {
                        m.Type = r.int32();
                        break;
                    }
                    case 9: {
                        m.NeedAes = r.bool();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        ValidateValueExistReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.ValidateValueExistReq";
        };

        return ValidateValueExistReq;
    })();

    Framework.RequestLog = (function () {

        function RequestLog(p) {
            this.Segments = [];
            this.RequestHeader = {};
            this.ResponseHeader = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RequestLog.prototype.RequestLogID = "";
        RequestLog.prototype.RequestIP = "";
        RequestLog.prototype.RequestTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        RequestLog.prototype.Protocol = "";
        RequestLog.prototype.RequestURL = "";
        RequestLog.prototype.Segments = $util.emptyArray;
        RequestLog.prototype.RequestMethod = "";
        RequestLog.prototype.RequestHeader = $util.emptyObject;
        RequestLog.prototype.RequestParam = null;
        RequestLog.prototype.ResponseHeader = $util.emptyObject;
        RequestLog.prototype.Response = null;
        RequestLog.prototype.TimeCost = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        RequestLog.create = function create(properties) {
            return new RequestLog(properties);
        };

        RequestLog.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.RequestLogID != null && Object.hasOwnProperty.call(m, "RequestLogID"))
                w.uint32(10).string(m.RequestLogID);
            if (m.RequestIP != null && Object.hasOwnProperty.call(m, "RequestIP"))
                w.uint32(18).string(m.RequestIP);
            if (m.RequestTime != null && Object.hasOwnProperty.call(m, "RequestTime"))
                w.uint32(24).int64(m.RequestTime);
            if (m.Protocol != null && Object.hasOwnProperty.call(m, "Protocol"))
                w.uint32(34).string(m.Protocol);
            if (m.RequestURL != null && Object.hasOwnProperty.call(m, "RequestURL"))
                w.uint32(42).string(m.RequestURL);
            if (m.Segments != null && m.Segments.length) {
                for (var i = 0; i < m.Segments.length; ++i)
                    w.uint32(50).string(m.Segments[i]);
            }
            if (m.RequestMethod != null && Object.hasOwnProperty.call(m, "RequestMethod"))
                w.uint32(58).string(m.RequestMethod);
            if (m.RequestHeader != null && Object.hasOwnProperty.call(m, "RequestHeader")) {
                for (var ks = Object.keys(m.RequestHeader), i = 0; i < ks.length; ++i) {
                    w.uint32(66).fork().uint32(10).string(ks[i]).uint32(18).string(m.RequestHeader[ks[i]]).ldelim();
                }
            }
            if (m.RequestParam != null && Object.hasOwnProperty.call(m, "RequestParam"))
                $root.google.protobuf.Struct.encode(m.RequestParam, w.uint32(74).fork()).ldelim();
            if (m.ResponseHeader != null && Object.hasOwnProperty.call(m, "ResponseHeader")) {
                for (var ks = Object.keys(m.ResponseHeader), i = 0; i < ks.length; ++i) {
                    w.uint32(82).fork().uint32(10).string(ks[i]).uint32(18).string(m.ResponseHeader[ks[i]]).ldelim();
                }
            }
            if (m.Response != null && Object.hasOwnProperty.call(m, "Response"))
                $root.Framework.Response.encode(m.Response, w.uint32(90).fork()).ldelim();
            if (m.TimeCost != null && Object.hasOwnProperty.call(m, "TimeCost"))
                w.uint32(96).int64(m.TimeCost);
            return w;
        };

        RequestLog.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.RequestLog(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.RequestLogID = r.string();
                        break;
                    }
                    case 2: {
                        m.RequestIP = r.string();
                        break;
                    }
                    case 3: {
                        m.RequestTime = r.int64();
                        break;
                    }
                    case 4: {
                        m.Protocol = r.string();
                        break;
                    }
                    case 5: {
                        m.RequestURL = r.string();
                        break;
                    }
                    case 6: {
                        if (!(m.Segments && m.Segments.length))
                            m.Segments = [];
                        m.Segments.push(r.string());
                        break;
                    }
                    case 7: {
                        m.RequestMethod = r.string();
                        break;
                    }
                    case 8: {
                        if (m.RequestHeader === $util.emptyObject)
                            m.RequestHeader = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.string();
                                    break;
                                case 2:
                                    value = r.string();
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.RequestHeader[k] = value;
                        break;
                    }
                    case 9: {
                        m.RequestParam = $root.google.protobuf.Struct.decode(r, r.uint32());
                        break;
                    }
                    case 10: {
                        if (m.ResponseHeader === $util.emptyObject)
                            m.ResponseHeader = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.string();
                                    break;
                                case 2:
                                    value = r.string();
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.ResponseHeader[k] = value;
                        break;
                    }
                    case 11: {
                        m.Response = $root.Framework.Response.decode(r, r.uint32());
                        break;
                    }
                    case 12: {
                        m.TimeCost = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        RequestLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.RequestLog";
        };

        return RequestLog;
    })();

    Framework.Response = (function () {

        function Response(p) {
            this.ExJson = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Response.prototype.Result = false;
        Response.prototype.Info = "";
        Response.prototype.Data = null;
        Response.prototype.AllowResponseJson = false;
        Response.prototype.PageSize = 0;
        Response.prototype.PageIndex = 0;
        Response.prototype.DataCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Response.prototype.PageCount = 0;
        Response.prototype.Status = 0;
        Response.prototype.ExJson = $util.emptyObject;
        Response.prototype.IsDownload = false;
        Response.prototype.RedirectUrl = "";
        Response.prototype.NoTip = false;
        Response.prototype.NoAnimation = false;
        Response.prototype.HTMLContent = "";
        Response.prototype.ID = "";
        Response.prototype.SyncID = "";

        Response.create = function create(properties) {
            return new Response(properties);
        };

        Response.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Result != null && Object.hasOwnProperty.call(m, "Result"))
                w.uint32(8).bool(m.Result);
            if (m.Info != null && Object.hasOwnProperty.call(m, "Info"))
                w.uint32(18).string(m.Info);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data"))
                $root.google.protobuf.Any.encode(m.Data, w.uint32(26).fork()).ldelim();
            if (m.AllowResponseJson != null && Object.hasOwnProperty.call(m, "AllowResponseJson"))
                w.uint32(32).bool(m.AllowResponseJson);
            if (m.PageSize != null && Object.hasOwnProperty.call(m, "PageSize"))
                w.uint32(40).int32(m.PageSize);
            if (m.PageIndex != null && Object.hasOwnProperty.call(m, "PageIndex"))
                w.uint32(48).int32(m.PageIndex);
            if (m.DataCount != null && Object.hasOwnProperty.call(m, "DataCount"))
                w.uint32(56).int64(m.DataCount);
            if (m.PageCount != null && Object.hasOwnProperty.call(m, "PageCount"))
                w.uint32(64).int32(m.PageCount);
            if (m.Status != null && Object.hasOwnProperty.call(m, "Status"))
                w.uint32(72).int32(m.Status);
            if (m.ExJson != null && Object.hasOwnProperty.call(m, "ExJson")) {
                for (var ks = Object.keys(m.ExJson), i = 0; i < ks.length; ++i) {
                    w.uint32(82).fork().uint32(10).string(ks[i]);
                    $root.google.protobuf.Value.encode(m.ExJson[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            if (m.IsDownload != null && Object.hasOwnProperty.call(m, "IsDownload"))
                w.uint32(88).bool(m.IsDownload);
            if (m.RedirectUrl != null && Object.hasOwnProperty.call(m, "RedirectUrl"))
                w.uint32(98).string(m.RedirectUrl);
            if (m.NoTip != null && Object.hasOwnProperty.call(m, "NoTip"))
                w.uint32(184).bool(m.NoTip);
            if (m.NoAnimation != null && Object.hasOwnProperty.call(m, "NoAnimation"))
                w.uint32(192).bool(m.NoAnimation);
            if (m.HTMLContent != null && Object.hasOwnProperty.call(m, "HTMLContent"))
                w.uint32(650).string(m.HTMLContent);
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(794).string(m.ID);
            if (m.SyncID != null && Object.hasOwnProperty.call(m, "SyncID"))
                w.uint32(802).string(m.SyncID);
            return w;
        };

        Response.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.Response(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Result = r.bool();
                        break;
                    }
                    case 2: {
                        m.Info = r.string();
                        break;
                    }
                    case 3: {
                        m.Data = $root.google.protobuf.Any.decode(r, r.uint32());
                        break;
                    }
                    case 4: {
                        m.AllowResponseJson = r.bool();
                        break;
                    }
                    case 5: {
                        m.PageSize = r.int32();
                        break;
                    }
                    case 6: {
                        m.PageIndex = r.int32();
                        break;
                    }
                    case 7: {
                        m.DataCount = r.int64();
                        break;
                    }
                    case 8: {
                        m.PageCount = r.int32();
                        break;
                    }
                    case 9: {
                        m.Status = r.int32();
                        break;
                    }
                    case 10: {
                        if (m.ExJson === $util.emptyObject)
                            m.ExJson = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.string();
                                    break;
                                case 2:
                                    value = $root.google.protobuf.Value.decode(r, r.uint32());
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.ExJson[k] = value;
                        break;
                    }
                    case 11: {
                        m.IsDownload = r.bool();
                        break;
                    }
                    case 12: {
                        m.RedirectUrl = r.string();
                        break;
                    }
                    case 23: {
                        m.NoTip = r.bool();
                        break;
                    }
                    case 24: {
                        m.NoAnimation = r.bool();
                        break;
                    }
                    case 81: {
                        m.HTMLContent = r.string();
                        break;
                    }
                    case 99: {
                        m.ID = r.string();
                        break;
                    }
                    case 100: {
                        m.SyncID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.Response";
        };

        return Response;
    })();

    Framework.Captcha = (function () {

        function Captcha(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Captcha.prototype.ID = "";
        Captcha.prototype.Value = "";

        Captcha.create = function create(properties) {
            return new Captcha(properties);
        };

        Captcha.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Value != null && Object.hasOwnProperty.call(m, "Value"))
                w.uint32(18).string(m.Value);
            return w;
        };

        Captcha.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.Captcha();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Value = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Captcha.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.Captcha";
        };

        return Captcha;
    })();

    Framework.FileInfo = (function () {

        function FileInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        FileInfo.prototype.ID = "";
        FileInfo.prototype.Suffix = "";
        FileInfo.prototype.Name = "";
        FileInfo.prototype.StoragePath = "";
        FileInfo.prototype.Data = $util.newBuffer([]);

        FileInfo.create = function create(properties) {
            return new FileInfo(properties);
        };

        FileInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Suffix != null && Object.hasOwnProperty.call(m, "Suffix"))
                w.uint32(18).string(m.Suffix);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(26).string(m.Name);
            if (m.StoragePath != null && Object.hasOwnProperty.call(m, "StoragePath"))
                w.uint32(130).string(m.StoragePath);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data"))
                w.uint32(162).bytes(m.Data);
            return w;
        };

        FileInfo.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Framework.FileInfo();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Suffix = r.string();
                        break;
                    }
                    case 3: {
                        m.Name = r.string();
                        break;
                    }
                    case 16: {
                        m.StoragePath = r.string();
                        break;
                    }
                    case 20: {
                        m.Data = r.bytes();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        FileInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Framework.FileInfo";
        };

        return FileInfo;
    })();

    return Framework;
})();

export const google = $root.google = (() => {

    const google = {};

    google.protobuf = (function () {

        const protobuf = {};

        protobuf.Any = (function () {

            function Any(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            Any.prototype.type_url = "";
            Any.prototype.value = $util.newBuffer([]);

            Any.create = function create(properties) {
                return new Any(properties);
            };

            Any.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.type_url != null && Object.hasOwnProperty.call(m, "type_url"))
                    w.uint32(10).string(m.type_url);
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(18).bytes(m.value);
                return w;
            };

            Any.decode = function decode(r, l, e) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Any();
                while (r.pos < c) {
                    var t = r.uint32();
                    if (t === e)
                        break;
                    switch (t >>> 3) {
                        case 1: {
                            m.type_url = r.string();
                            break;
                        }
                        case 2: {
                            m.value = r.bytes();
                            break;
                        }
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };

            Any.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Any";
            };

            return Any;
        })();

        protobuf.Struct = (function () {

            function Struct(p) {
                this.fields = {};
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            Struct.prototype.fields = $util.emptyObject;

            Struct.create = function create(properties) {
                return new Struct(properties);
            };

            Struct.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.fields != null && Object.hasOwnProperty.call(m, "fields")) {
                    for (var ks = Object.keys(m.fields), i = 0; i < ks.length; ++i) {
                        w.uint32(10).fork().uint32(10).string(ks[i]);
                        $root.google.protobuf.Value.encode(m.fields[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                    }
                }
                return w;
            };

            Struct.decode = function decode(r, l, e) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Struct(), k, value;
                while (r.pos < c) {
                    var t = r.uint32();
                    if (t === e)
                        break;
                    switch (t >>> 3) {
                        case 1: {
                            if (m.fields === $util.emptyObject)
                                m.fields = {};
                            var c2 = r.uint32() + r.pos;
                            k = "";
                            value = null;
                            while (r.pos < c2) {
                                var tag2 = r.uint32();
                                switch (tag2 >>> 3) {
                                    case 1:
                                        k = r.string();
                                        break;
                                    case 2:
                                        value = $root.google.protobuf.Value.decode(r, r.uint32());
                                        break;
                                    default:
                                        r.skipType(tag2 & 7);
                                        break;
                                }
                            }
                            m.fields[k] = value;
                            break;
                        }
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };

            Struct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Struct";
            };

            return Struct;
        })();

        protobuf.Value = (function () {

            function Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            Value.prototype.nullValue = null;
            Value.prototype.numberValue = null;
            Value.prototype.stringValue = null;
            Value.prototype.boolValue = null;
            Value.prototype.structValue = null;
            Value.prototype.listValue = null;

            let $oneOfFields;

            Object.defineProperty(Value.prototype, "kind", {
                get: $util.oneOfGetter($oneOfFields = ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            Value.create = function create(properties) {
                return new Value(properties);
            };

            Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.nullValue != null && Object.hasOwnProperty.call(m, "nullValue"))
                    w.uint32(8).int32(m.nullValue);
                if (m.numberValue != null && Object.hasOwnProperty.call(m, "numberValue"))
                    w.uint32(17).double(m.numberValue);
                if (m.stringValue != null && Object.hasOwnProperty.call(m, "stringValue"))
                    w.uint32(26).string(m.stringValue);
                if (m.boolValue != null && Object.hasOwnProperty.call(m, "boolValue"))
                    w.uint32(32).bool(m.boolValue);
                if (m.structValue != null && Object.hasOwnProperty.call(m, "structValue"))
                    $root.google.protobuf.Struct.encode(m.structValue, w.uint32(42).fork()).ldelim();
                if (m.listValue != null && Object.hasOwnProperty.call(m, "listValue"))
                    $root.google.protobuf.ListValue.encode(m.listValue, w.uint32(50).fork()).ldelim();
                return w;
            };

            Value.decode = function decode(r, l, e) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    if (t === e)
                        break;
                    switch (t >>> 3) {
                        case 1: {
                            m.nullValue = r.int32();
                            break;
                        }
                        case 2: {
                            m.numberValue = r.double();
                            break;
                        }
                        case 3: {
                            m.stringValue = r.string();
                            break;
                        }
                        case 4: {
                            m.boolValue = r.bool();
                            break;
                        }
                        case 5: {
                            m.structValue = $root.google.protobuf.Struct.decode(r, r.uint32());
                            break;
                        }
                        case 6: {
                            m.listValue = $root.google.protobuf.ListValue.decode(r, r.uint32());
                            break;
                        }
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };

            Value.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Value";
            };

            return Value;
        })();

        protobuf.NullValue = (function () {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "NULL_VALUE"] = 0;
            return values;
        })();

        protobuf.ListValue = (function () {

            function ListValue(p) {
                this.values = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            ListValue.prototype.values = $util.emptyArray;

            ListValue.create = function create(properties) {
                return new ListValue(properties);
            };

            ListValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.values != null && m.values.length) {
                    for (var i = 0; i < m.values.length; ++i)
                        $root.google.protobuf.Value.encode(m.values[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            ListValue.decode = function decode(r, l, e) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.ListValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    if (t === e)
                        break;
                    switch (t >>> 3) {
                        case 1: {
                            if (!(m.values && m.values.length))
                                m.values = [];
                            m.values.push($root.google.protobuf.Value.decode(r, r.uint32()));
                            break;
                        }
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };

            ListValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.ListValue";
            };

            return ListValue;
        })();

        return protobuf;
    })();

    return google;
})();

export {$root as default};
